export default __webpack_public_path__ + "static/media/JeepBG.a2969fd1.png";